export default function(ctx) {
  if (window.onGigyaServiceReady) {
    return
  }

  window.onGigyaServiceReady = function() {
    setTimeout(() => {
      if (!ctx.store.state['access-token'].isAccessToken) {
        console.log('No accessToken from the native app - Show Gigya login')
        ctx.store.commit('setGigyaReady', true)
      }
    }, 8000)
  }

  function handleLogin() {
    ctx.store.commit('setLoggedInEventReceived', true)
  }

  document.addEventListener('pwalogin', handleLogin)
}
